exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".loading-btn{padding:5px 40px}.loading-btn .spinner{display:block;width:22px;height:22px;margin:0 auto}@media(min-width: 1160px){.loading-btn .spinner{width:32px;height:32px}}.loading-btn .spinner:after{width:16px;height:16px;border:3px solid #fff;border-color:#fff rgba(0,0,0,0) #fff #fff}@media(min-width: 1160px){.loading-btn .spinner:after{width:23px;height:23px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib??postcss!./node_modules/sass-loader/dist/cjs.js!./src/components/loading-button/style.scss
// module id = 1345
// module chunks = 57